import React, { useEffect } from 'react'; // ✅ useEffect added
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'; // ✅ useLocation added
import { Box } from '@mui/material';
import { LocationProvider, LocationDialogProvider } from './contexts/LocationContext';
// import { SearchProvider } from './contexts/SearchContext';
import Navbar from './components/Navbar';
import Homepage from './Pages/Homepage';
import Signup from './Pages/Signup';
import Login from './Pages/Login';
import DealsList from './Pages/DealsList';
import VendorsList from './Pages/VendorsList';
import FavouriteDeals from './Pages/FavouriteDeals';
import DealDetails from './Pages/DealDetails';
import Profile from './Pages/Profile';
import Errorpage from './Pages/ErrorPage';
import Career from './Pages/Career';
import About from './Pages/About';
import Contact from './Pages/Contact';
import VendorDetails from './Pages/VendorDetails';
import ForgetPassword from './Pages/ForgetPassword';
import Footer from './components/Footer';

import VendorLogin from './Pages/Vendor/VendorLogin';
import VendorRegister from './Pages/Vendor/VendorRegister';
import VendorDashboard from './Pages/Vendor/VendorDashboard';
import VendorDeals from './Pages/Vendor/VendorDeals';
import EditDeal from './Pages/Vendor/EditDeal';
import AddDeals from './Pages/Vendor/AddDeals';
import VendorForgotPassword from './Pages/Vendor/VendorForgotPassword';

import AdmLogin from './Pages/adm/AdmLogin';
import AdmDashboard from './Pages/adm/AdmDashboard';
import AddVendor from './Pages/adm/AddVendor';
import FAQ from './Pages/FAQ';
import Terms from './Pages/Terms';

/* ✅ INLINE scroll-to-top logic */
function ScrollToTopHandler() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      {/* ✅ Scroll handler mounted once */}
      <ScrollToTopHandler />

      <LocationProvider>
        <LocationDialogProvider>
          {/* <SearchProvider> */}
          <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Navbar />
            <Box component="main" sx={{ flexGrow: 1 }}>
              <Routes>
                <Route path="/" element={<Homepage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/deals" element={<DealsList />} />
                <Route path="/vendors" element={<VendorsList />} />
                <Route path="/shop" element={<DealsList />} />
                <Route path="/favorite" element={<FavouriteDeals />} />
                <Route path="/deal/:id" element={<DealDetails />} />
                <Route path="/vendor/:vendorId" element={<VendorDetails />} />
                <Route path="/Profile" element={<Profile />} />
                <Route path="/careers" element={<Career />} />  
                <Route path="/About" element={<About />} />
                <Route path="/Contact" element={<Contact />} />
                <Route path="/forgot-password" element={<ForgetPassword />} />

                <Route path="/Vendor/Login" element={<VendorLogin />} />
                <Route path="/Vendor/Register" element={<VendorRegister />} />
                <Route path="/Vendor/Dashboard" element={<VendorDashboard />} />
                <Route path="/Vendor/Vendor-forgot-Password" element={<VendorForgotPassword />} />
                <Route path="/Vendor/Deals/view" element={<VendorDeals />} />
                <Route path="/vendor/deals/:dealId/edit" element={<EditDeal />} />
                <Route path="/vendor/add_deals" element={<AddDeals />} />

                <Route path="/Admin/Login" element={<AdmLogin />} />
                <Route path="/Admin/Dashboard" element={<AdmDashboard />} />
                <Route path="/Admin/Vendors/add" element={<AddVendor />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="*" element={<Errorpage />} />
              </Routes>
            </Box>
            <Footer />
          </Box>
          {/* </SearchProvider> */}
        </LocationDialogProvider>
      </LocationProvider>
    </Router>
  );
}

export default App;
